import { render, staticRenderFns } from "./costInfo.vue?vue&type=template&id=8d07b02e"
import script from "./costInfo.vue?vue&type=script&lang=js"
export * from "./costInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports